const $ = require("jquery");

function autoHeightTextarea() {
    $(".autoheight").each(function () {
        if(!$(this).hasClass("returnhtml")) {
            let currentHeight = $(".autoheight").height();
            let scrollHeight = this.scrollHeight;
            if (scrollHeight - 10 > currentHeight) {
                this.setAttribute("style", "height:" + (this.scrollHeight) + "px;");
            }
        }
    })
}

function toggleWideMode(hide) {
    $("input[name='useWideMode']").prop('checked', hide);
    localStorage.setItem('useWideMode', hide);
    if (hide === true) {
        $(".widemode-toggle .enabled").show();
        $(".widemode-toggle .disabled").hide();
        $("body").addClass("widemode");
    } else {
        $(".widemode-toggle .enabled").hide();
        $(".widemode-toggle .disabled").show();
        $("body").removeClass("widemode");
    }
}

function isTrue(setting) {
    return setting !== undefined && (setting === true || setting === "true")
}


$(document).ready(function () {

    let editor_form = $('.php-editor-form');

    function saveSetting(setting, value) {
        userSettings[setting] = value;
        localStorage.setItem('userSettings', JSON.stringify(userSettings));
    }

    $(".user-options").change(function () {
        userSettings[$(this).prop("name")] = ($(this).prop("checked"));
        localStorage.setItem('userSettings', JSON.stringify(userSettings));
    })
    $(".user-options-select").change(function () {
        userSettings[$(this).prop("name")] = ($(this).val());
        localStorage.setItem('userSettings', JSON.stringify(userSettings));
    })

    // Wide Mode
    $(".widemode-toggle").click(function () {
        $("input[name='useWideMode']").trigger("click");
    });
    let hide_right_menu = localStorage.getItem('useWideMode');
    toggleWideMode(isTrue(hide_right_menu));
    $("input[name='useWideMode']").change(function () {
        let hide = $(this).is(":checked");
        toggleWideMode(hide);
        $("input[name='hideSandboxText']").prop("checked", hide).trigger("change");
    })

    /**
     * Left Right Layout
     */
    function toggleLeftRight(enabled, size) {
        let maxWidth = $(".editor-container").width() - 5;
        if (size === -1 && enabled) {
            size = ($(".editor-container").width() * 0.6)
        }
        if (size === -1 && !enabled) {
            size = 1500
        }
        if (size > maxWidth) {
            size = maxWidth;
        }

        saveSetting('leftRight', enabled);
        saveSetting('leftRightWidth', size);

        if (isTrue(enabled)) {
            let height_l = parseInt($(".panel-left").height(), 10);
            let height_r = parseInt($(".panel-right").height(), 10);
            let height_ace = parseInt($("#editor_sandboxform").height(), 10);

            $(".panel-right").show().css("height", height_l  + "px");
            $(".panel-left").css("width", size + "px");
            $("#output_sandboxform").hide().prop("id", "output_sandboxform_disabled");

            $(".leftrightmode-toggle .enabled").hide();
            $(".leftrightmode-toggle .disabled").show();
            autoHeightTextarea()

        } else {
            $(".panel-right").hide();
            $(".panel-left").css("width", "calc(100% - 5px)");
            $("#output_sandboxform").show().prop("id", "output_sandboxform");
            $("#output_sandboxform_disabled").show().prop("id", "output_sandboxform");

            $(".leftrightmode-toggle .enabled").show();
            $(".leftrightmode-toggle .disabled").hide();
            autoHeightTextarea()
        }
    }


    toggleLeftRight(userSettings.leftRight, userSettings.leftRightWidth);

    $("input[name='leftRight']").prop("checked", isTrue(userSettings.leftRight))
    $(".leftrightmode-toggle").click(function () {
        $("input[name='leftRight']").trigger("click");
    });
    $("input[name='leftRight']").change(function () {
        let hide = $(this).is(":checked");
        toggleLeftRight(hide, -1);
    })

    /**
     * Sandbox Text Hide
     */

    function toggleSandboxText(hide){
        if(hide){
            $(".sandbox-text").hide();
        }else{
            $(".sandbox-text").show();
        }
    }

    toggleSandboxText(userSettings.hideSandboxText);

    $("input[name='hideSandboxText']").prop("checked", isTrue(userSettings.hideSandboxText))
    $("input[name='hideSandboxText']").change(function () {
        let hide = $(this).is(":checked");
        toggleSandboxText(hide,);
    })



    /**
     * Output Colorization
     */
    if(isTrue(userSettings.colorizeOutput)){
        $("input[name='loadThemeSettings']").trigger("change");
    }


    // Editor output
    if( $("#selected-output-from-code").length > 0){
        if($("#selected-output-from-code").val() === "textarea"){
            $("input[name='output'][value='textarea']").attr('checked', true);
        }else{
            $("input[name='output'][value='html']").attr('checked', true);
        }
    }else{
        let editor_output = localStorage.getItem('editor_output');
        if (editor_output) {
            $("input[name='output'][value='" + editor_output + "']").attr('checked', true);
        } else {
            $("input[name='output'][value='textarea']").attr('checked', true);
        }
    }

    $("input[name='output']").change(function () {
        localStorage.setItem('editor_output', $("input[name='output']:checked").val());
    })

    // Layout
    let editor_layout = localStorage.getItem('editor-layout');
    if (editor_layout) {
        $("input[name='editor-layout'][value='" + editor_layout + "']").attr('checked', 'checked');
    } else {
        $("input[name='editor-layout'][value='top']").attr('checked', 'checked');
    }

    $("input[name='editor-layout']").change(function () {
        $(this).attr("name")
        localStorage.setItem($(this).attr("name"), $(this).val());
    })

    // Error Reporting
    let error_reporting = localStorage.getItem('error_reporting');
    if (error_reporting) {
        error_reporting = JSON.parse(error_reporting)
        $.each(error_reporting, function (key, val) {
            $(".error_reporting[value='" + val + "']").prop('checked', true);
        });

    } else {
        $(".error_reporting").prop('checked', true);
        $(".error_reporting[value='0']").prop('checked', false);
    }

    $(".error_reporting").change(function () {
        if ($(this).val() === 'E_ALL' && $(this).is(":checked")) {
            $(".error_reporting").prop('checked', true);
            $(".error_reporting[value='0']").prop('checked', false);
        } else if ($(this).val() !== "0" && $(this).is(":checked")) {
            $(".error_reporting[value='0']").prop('checked', false);
        } else if ($(this).val() === "0" && $(this).is(":checked")) {
            $(".error_reporting").prop('checked', false);
            $(".error_reporting[value='0']").prop('checked', true);
        }

        let allVals = [];
        $(".error_reporting:checked").each(function (i) {
            allVals[i] = $(this).val();
        });
        localStorage.setItem('error_reporting', JSON.stringify(allVals));
    })


    // no-ads
    if (userNoAds) {
        $("input[name='no-ads']").prop("checked", "checked");
    }
    $("input[name='no-ads']").change(function () {
        if ($(this).is(":checked") && userHP) {
            userNoAds = true
            $.post("/ajax/saveSetting/no-ads", {'value': 'on'});
            $(".adsbygoogle").fadeOut();
        } else {
            userNoAds = false
            $.post("/ajax/saveSetting/no-ads", {'value': 'off'});
            $(".adsbygoogle").fadeIn();
        }
    })

    // no-captcha
    if (userNoCaptcha) {
        $("input[name='no-captcha']").prop("checked", "checked");
    }
    $("input[name='no-captcha']").change(function () {
        if ($(this).is(":checked")) {
            userNoCaptcha = true
            $.post("/ajax/saveSetting/no-captcha", {'value': 'on'});
        } else {
            userNoCaptcha = false
            $.post("/ajax/saveSetting/no-captcha", {'value': 'off'});
        }
    })

    // disable-comments
    if (userNoComments) {
        $("input[name='disable-comments']").prop("checked", "checked");
    }
    $("input[name='disable-comments']").change(function () {
        if ($(this).is(":checked") && userHP) {
            userNoComments = true
            $.post("/ajax/saveSetting/disable-comments", {'value': 'on'});
            $(".sb-fb-comments").fadeOut();
        } else {
            userNoComments = false
            $.post("/ajax/saveSetting/disable-comments", {'value': 'off'});
            $(".sb-fb-comments").fadeIn();
        }
    })


    var currentWidth = 9000;
    var maxWidth = 1000;
    var showRightWidth = 1000;
    $(".panel-left").resizable({
        handleSelector: ".splitter",
        handleSelectorUpDown: "lowersplitter",
        resizeHeight: true,
        onDragEnd: function (e) {
            let width_l = parseInt($(".panel-left").width(), 10);
            let width_r = parseInt($(".panel-right").width(), 10);

            if (width_l > maxWidth) {
                toggleLeftRight(false, width_l)
            }
            if ((maxWidth - width_l) < 35) {
                toggleLeftRight(false, width_l)
            }
            if ((maxWidth - width_l) >= 35) {
                if (width_l < 40) {
                    toggleLeftRight(true, 35)
                } else {
                    toggleLeftRight(true, width_l)
                }
            }
        },
        onDragStart: function (e) {
            autoHeightTextarea()
            currentWidth = e.clientX
            maxWidth = parseInt($(".editor-container").width(), 10) - 5;
            showRightWidth = maxWidth - 40
        },
        onDrag: function (e) {
            let width = parseInt($(".panel-left").width(), 10);
            let height_l = parseInt($(".panel-left").height(), 10);
            if (width > maxWidth && e.clientX > currentWidth) {
                return false;
            } else if (width < showRightWidth) {
                $(".panel-right").show().css("height", height_l  + "px");
                $("#output_sandboxform").hide();
            } else {
                $(".panel-right").hide();
                $("#output_sandboxform").show();
            }

            currentWidth = e.clientX
        }
    });

    $("body").on("click", "#hidecurlerror", function(){
        localStorage.setItem('hidecurlerror', "hide");
        $("#content-container").addClass("hide-warning");
        $(".curl_warning").hide();
    });
    let hidecurlerror = localStorage.getItem('hidecurlerror');
    if (hidecurlerror) {
        $("#content-container").addClass("hide-warning");
    }

});

